import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";

const LINKS = [
  { label: "Inicio", id: "inicio" },
  { label: "Servicios", id: "servicios" },
  { label: "Galería", id: "galeria" },
  { label: "Opiniones", id: "opiniones" },
  { label: "Contacto", id: "contacto" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/#" + id);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 z-40 w-full transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-background/70 border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="font-serif-display text-2xl font-semibold tracking-tight">
            Lupita
          </span>
          <span className="overline mt-1 text-primary">Estética</span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => goSection(l.id)}
              className="text-sm text-muted-foreground transition-colors hover:text-primary"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <Link
            to="/login"
            data-testid="navbar-admin-link"
            className="hidden text-sm text-muted-foreground transition-colors hover:text-primary sm:block"
          >
            Admin
          </Link>
          <Link
            to="/reservar"
            data-testid="navbar-book-btn"
            className="rounded-none bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-gold-dark"
          >
            Reservar
          </Link>
        </div>
      </div>
    </header>
  );
}
